import FormDialog from "../../../components/common/FormDialog";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";

const AreaStatsDialog = ({ cityName, areaMap, open, onClose, rows = [] }) => {
  return (
    <FormDialog title={`${cityName}区业绩`} open={open} onClose={onClose}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">区域</TableCell>
              <TableCell align="left">业绩</TableCell>
              {/* <TableCell align="left">月业绩（元）</TableCell>
              <TableCell align="left">昨日业绩（元）</TableCell>
              <TableCell align="left">今日业绩（元）</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell align="left">{areaMap[row.districtId]}</TableCell>
                <TableCell align="left">{row.rangli}</TableCell>
                {/* <TableCell align="left">{row.yearly.toFixed(2)}</TableCell>
                <TableCell align="left">{row.monthly.toFixed(2)}</TableCell>
                <TableCell align="left">{row.yesterday.toFixed(2)}</TableCell>
                <TableCell align="left">{row.today.toFixed(2)}</TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </FormDialog>
  );
};

export default AreaStatsDialog;
